module.exports = [
  "Makie",
  "Makiek",
  "Malagwa",
  "Marusha",
  "Mbembe",
  "Mbende",
  "Mbondei",
  "Mbungu",
  "Mburunge",
  "Mchagga",
  "Mdatoga",
  "Mdhaiso",
  "Mdigo",
  "Mdoe",
  "Mfipa",
  "Mgogo",
  "Mgoma",
  "Mgorowa",
  "Mgweno",
  "Mha",
  "Mhadzabe",
  "Mhangaza",
  "Mhaya",
  "Mhehe",
  "Mhinda",
  "Mhutu",
  "Mikizu",
  "Mikoma",
  "Miraqw",
  "Misanzu",
  "Mjita",
  "Mkabwa",
  "Mkaguru",
  "Mkahe",
  "Mkami",
  "Mkara",
  "Mkerewe",
  "Mkimbu",
  "Mkinga",
  "Mkisankasa",
  "Mkisi",
  "Mkonongo",
  "Mkutu",
  "Mkw'Adza",
  "Mkwavi",
  "Mkwaya",
  "Mkwere",
  "Mlambya",
  "Mlongo",
  "Mluguru",
  "Mmachinga",
  "Mmagoma",
  "Mmahanji",
  "Mmakonde",
  "Mmakua",
  "Mmakwe",
  "Mmalila",
  "Mmambwe",
  "Mmanda",
  "Mmanyema",
  "Mmasai",
  "Mmatengo",
  "Mmatumbi",
  "Mmaviha",
  "Mmbugwe",
  "Mmbunga",
  "Mmpoto",
  "Mmwera",
  "Mndali",
  "Mndamba",
  "Mndendeule",
  "Mndengereko",
  "Mndonde",
  "Mnena",
  "Mngasa",
  "Mngindo",
  "Mngoni",
  "Mngulu",
  "Mngurimi",
  "Mnilamba",
  "Mnindi",
  "Mnyakyusa",
  "Mnyambo",
  "Mnyamwanga",
  "Mnyamwezi",
  "Mnyanyembe",
  "Mnyasa",
  "Mnyaturu",
  "Mnyiha",
  "Mpangwa",
  "Mpare",
  "Mpimbwe",
  "Mpogolo",
  "Mrangi",
  "Mrufiji",
  "Mrungi",
  "Mrungu",
  "Mrungwa",
  "Msafwa",
  "Msagara",
  "Msandawe",
  "Msangu",
  "Msegeju",
  "Mshambaa",
  "Mshirazi",
  "Mshubi",
  "Msizaki",
  "Msuba",
  "Msukuma",
  "Msumbwa",
  "Mswahili",
  "Mtaveta",
  "Mtemi",
  "Mtongwe",
  "Mtumbuka",
  "Mvidunda",
  "Mvinza",
  "Mwanda",
  "Mwanji",
  "Mware",
  "Mzanaki",
  "Mzaramo",
  "Mzigula",
  "Mzinza",
  "Mzyoba",
];
